import React from "react";
import { MDBContainer } from 'mdb-react-ui-kit';
import Navbar from "./components/Navbar";
import Leden from './components/Ledenlijst';
import Footer from "./components/Footer";



export default function Content() {


  return (        
    <div className="page-container">
      <MDBContainer>
      <div className="d-flex align-items-center">
        <div className="d-flex flex-column mb-3 w-100">
          <div className="p-2 w-100 navwrapper bg-light"><Navbar /></div>
            <div className="w-100 pageWrapper">
            <div className="page">
                <div className="title"><h1>Leden</h1></div>
                
                <div className="content"><Leden/></div>
              </div>
            </div>
        </div>
      </div>
      <Footer />
      </MDBContainer>
      
    </div>
  );
}